import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router';
import { FormattedMessage } from 'react-intl';
import { ga } from 'helpers/multitrack';
import { segment } from 'helpers/segment';
import { PagePromotionCta } from 'components/PagePromotion';

export class NavigationCta extends Component {
  handleCtaClick() {
    segment.track('Top Nav', {
      action: 'Get ClassPass',
    });
    ga('Top Nav', 'Get ClassPass');
  }

  render() {
    const { isActiveUser, isCancelledUser, className } = this.props;

    if (isActiveUser) {
      return null;
    }

    if (isCancelledUser) {
      return (
        <Link className="bt bt--sm bt--text-sm header__bt" to="/rejoin">
          <FormattedMessage id="header.reactivateCta" defaultMessage="Reactivate" />
        </Link>
      );
    }

    return (
      <PagePromotionCta
        extraClassForLink={classNames(className, 'bt--primary bt--sm bt--text-sm header__bt')}
        onClick={this.handleCtaClick}
        ctaCopy={<FormattedMessage id="header.getCta" defaultMessage="Get ClassPass" />}
      />
    );
  }
}

NavigationCta.propTypes = {
  className: PropTypes.string,
  isActiveUser: PropTypes.bool,
  isCancelledUser: PropTypes.bool,
};
